<template lang="pug">
  select.my-2(
    v-model="selectedHost"
    v-bind:disabled="loading"
    v-bind:class="{ 'bg-gray-300': loading }"
  )
    option(v-for="(hostName, index) in Object.keys(hosts)" :value="hosts[hostName]") {{hostName}}
</template>
<style lang="postcss" scoped>
select {
  @apply ml-auto appearance-none bg-no-repeat bg-white border border-gray-400 px-3 py-2 pr-8 rounded shadow leading-tight;
  -webkit-appearance: none;
  background-image: svg-load("../assets/icons/expand.svg");
  background-position: 96% center;
  background-size: 15px;
  min-width: 200px;
}

select:hover {
  @apply border-gray-500;
}

select:focus {
  @apply outline-none shadow-outline;
}
</style>
<script>
import common_computed from "@/mixins/common_computed";
export default {
  mixins: [common_computed],
  computed: {
    hosts() {
      return this.$store.state.hosts;
    },
  },
};
</script>
